import { thunk, action } from 'easy-peasy'
import { responseHandler, defaultHeaders } from 'utils/api'

export default {
  verifyEmailState: { status: 0, payload: null },
  setVerifyEmailState: action((state, payload = null) => {
    state.verifyEmailState = payload
  }),
  verifyEmail: thunk(async (actions, data) => {
    actions.setVerifyEmailState({ status: 1, payload: null })

    const response = await fetch('/api/auth/verify_email', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        ...defaultHeaders,
        'Cache-Control': 'no-cache'
      }
    })

    const { status, payload } = await responseHandler(response)

    actions.setVerifyEmailState({ status, payload })
  }),

  forceResetOtpState: { status: 0, payload: null },
  setForceResetOtpState: action((state, payload = null) => {
    state.forceResetOtpState = payload
  }),
  forceResetOtp: thunk(async (actions, data) => {
    actions.setForceResetOtpState({ status: 1, payload: null })

    const response = await fetch('/api/auth/force_reset/request_otp', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { ...defaultHeaders, 'Cache-Control': 'no-cache' }
    })

    const { status, payload } = await responseHandler(response)

    actions.setForceResetOtpState({ status, payload })
  }),

  resendOtpState: { status: 0, payload: null },
  setResendOtpState: action((state, payload = null) => {
    state.resendOtpState = payload
  }),
  resendOtp: thunk(async (actions, data) => {
    actions.setResendOtpState({ status: 1, payload: null })

    const response = await fetch('/api/auth/force_reset/resend_otp', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { ...defaultHeaders, 'Cache-Control': 'no-cache' }
    })

    const { status, payload } = await responseHandler(response)

    actions.setResendOtpState({ status, payload })
  }),

  forceResetVerifyOtpState: { status: 0, payload: null },
  setForceResetVerifyOtpState: action((state, payload = null) => {
    state.forceResetVerifyOtpState = payload
  }),
  forceResetVerifyOtp: thunk(async (actions, data) => {
    actions.setForceResetVerifyOtpState({ status: 1, payload: null })

    const response = await fetch('/api/auth/force_reset/verify_otp', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { ...defaultHeaders, 'Cache-Control': 'no-cache' }
    })

    const { status, payload } = await responseHandler(response)

    actions.setForceResetVerifyOtpState({ status, payload })
  }),

  forceUpdatePasswordState: { status: 0, payload: null },
  setForceUpdatePasswordState: action((state, payload = null) => {
    state.forceUpdatePasswordState = payload
  }),
  forceUpdatePassword: thunk(async (actions, data) => {
    actions.setForceUpdatePasswordState({ status: 1, payload: null })
    console.log('data', data)
    const response = await fetch('/api/auth/force_reset/force_update_password', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { ...defaultHeaders, 'Cache-Control': 'no-cache' }
    })

    const { status, payload } = await responseHandler(response)

    actions.setForceUpdatePasswordState({ status, payload })
  })
}
